import Component from '../../../assets/scripts/modules/component'
import SwiperWrapper from '../../../assets/scripts/modules/swiper-wrapper'

const SWIPER_OPTIONS_CONTENT = {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  allowTouchMove: true,
  grabCursor: true,
  effect: 'slide',
  autoHeight: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.image-carousel__pagination',
    clickable: true,
    renderBullet: (index, className) => {
      return `<span class="swiper-pagination-bullet"></span>`
    }
  }
}

export default class ImageCarouselComponent extends Component {
  async init () {
    this.contentContainer = this.element.querySelector('.image-carousel__content-container.swiper-container')

    if (!this.contentContainer) {
      return
    }

    this.loadContentSwiper()
  }

  loadContentSwiper () {
    const options = { ...SWIPER_OPTIONS_CONTENT }
    this.contentSwiperWrapper = new SwiperWrapper(this.contentContainer, options)
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.image-carousel').forEach(element => {
  element.instance = element.instance || new ImageCarouselComponent(element)
}))
